
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/line/referral/[liffId]",
      function () {
        return require("private-next-pages/line/referral/[liffId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/line/referral/[liffId]"])
      });
    }
  